import { Button } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    min-width: fit-content;
`;
